// Actions
export const setOperations = ({ commit }, payload) => {
  commit('SET_OPERATIONS', payload)
}
export const addOperations = ({ commit }, payload) => {
  commit('ADD_OPERATIONS', payload)
}
export const setOperationsLoading = ({ commit }, payload) => {
  commit('SET_OPERATIONS_LOADING', payload)
}
export const removeOperation = ({commit}, payload) => {
  commit('REMOVE_OPERATION', payload)
}

export const setClients = ({ commit }, payload) => {
  commit('SET_CLIENTS', payload)
}
export const addClients = ({ commit }, payload) => {
  commit('ADD_CLIENTS', payload)
}
export const setClientsLoading = ({ commit }, payload) => {
  commit('SET_CLIENTS_LOADING', payload)
}

export const setClientAssets = ({ commit }, payload) => {
  commit('SET_CLIENT_ASSETS', payload)
}
export const addClientAssets = ({ commit }, payload) => {
  commit('ADD_CLIENT_ASSETS', payload)
}
export const setClientAssetsLoading = ({ commit }, payload) => {
  commit('SET_CLIENT_ASSETS_LOADING', payload)
}

export const setAssets = ({ commit }, payload) => {
  commit('SET_ASSETS', payload)
}
export const addAssets = ({ commit }, payload) => {
  commit('ADD_ASSETS', payload)
}
export const setAssetsLoading = ({ commit }, payload) => {
  commit('SET_ASSETS_LOADING', payload)
}
export const setAssetsMetadata = ({commit}, payload) => {
  commit('SET_ASSETS_METADATA', payload)
}

export const setClientAccount = ({ commit }, payload) => {
  commit('SET_CLIENT_ACCOUNT', payload)
}
export const addClientAccount = ({ commit }, payload) => {
  commit('ADD_CLIENT_ACCOUNT', payload)
}
export const setClientAccountLoading = ({ commit }, payload) => {
  commit('SET_CLIENT_ACCOUNT_LOADING', payload)
}

export const setClientExtract = ({ commit }, payload) => {
  commit('SET_CLIENT_EXTRACT', payload)
}
export const addClientExtract = ({ commit }, payload) => {
  commit('ADD_CLIENT_EXTRACT', payload)
}
export const setClientExtractLoading = ({ commit }, payload) => {
  commit('SET_CLIENT_EXTRACT_LOADING', payload)
}
export const setClientExtractMetadata = ({ commit }, payload) => {
  commit('SET_CLIENT_EXTRACT_METADATA', payload)
}

export const setTranches = ({ commit }, payload) => {
  commit('SET_TRANCHES', payload)
}
export const addTranches = ({ commit }, payload) => {
  commit('ADD_TRANCHES', payload)
}
export const setTranchesLoading = ({ commit }, payload) => {
  commit('SET_TRANCHES_LOADING', payload)
}


export const setCashback = ({ commit }, payload) => {
  commit('SET_CASHBACK', payload)
}
export const addCashback = ({ commit }, payload) => {
  commit('ADD_CASHBACK', payload)
}
export const setCashbackLoading = ({ commit }, payload) => {
  commit('SET_CASHBACK_LOADING', payload)
}

export const setSolicitacoes = ({ commit }, payload) => {
  commit('SET_SOLICITACOES', payload)
}
export const addSolicitacoes = ({ commit }, payload) => {
  commit('ADD_SOLICITACOES', payload)
}
export const setSolicitacoesLoading = ({ commit }, payload) => {
  commit('SET_SOLICITACOES_LOADING', payload)
}
export const setSolicitacoesCatalogo = ({ commit }, payload) => {
  commit('SET_SOLICITACOES_CATALOGO', payload)
}

